import { Injectable } from '@angular/core';
import { AjaxObservableService } from '../../../services/ajax-observable.service';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable()
export class BonusService {
  eligibleBonusCode:any;
  eligibleBonusData;
  specialBonus;
  bonusesLength = 0;
  activeFreeSpinsData;
  activeBonusList;
  eligibleBonusList;

  private eligibleBonusRefresh = new BehaviorSubject<any>(null);
  public eligibleBonusRefresh$ = this.eligibleBonusRefresh.asObservable();

  private eligibleBonusDataRefresh = new BehaviorSubject<any>(null);
  public eligibleBonusDataRefresh$ = this.eligibleBonusDataRefresh.asObservable();

  broadRefreshEligibleBonus(data) {
    this.eligibleBonusRefresh.next(data);
    this.setEligibleBonusCode(undefined);
  }

  broadRefreshEligibleBonusData(data) {
    this.eligibleBonusDataRefresh.next(data);
    this.setEligibleBonusData(data);
  }


  constructor(private ajaxService: AjaxObservableService) { }

  dropBonus(bonusId): Observable<any> {
    return this.ajaxService.dropBonus({ecrBonusId : bonusId });
  }

  getEligibleBonus(): Observable<any>{
    return this.ajaxService.getEligibleBonus({ criteriaType: 'DEPOSIT' });
  }
  
  setSpecialBonus(bonus){
    this.specialBonus = bonus;
  }
  getSpecialBonus(){
   return this.specialBonus;
  }
  setEligibleBonusData(bonusData){
    this.eligibleBonusData = bonusData;
  }

  getEligibleBonusData(){
    return this.eligibleBonusData;
  }

  setEligibleBonusCode(bonusData){
    this.eligibleBonusCode = bonusData;
  }

  getEligibleBonusCode(){
    return this.eligibleBonusCode;
  }

}
